import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { type PropType } from 'vue';

import { type ModalVariant } from '@exchange/libs/modals/src';


export default /*#__PURE__*/_defineComponent({
  __name: 'SubaccountTransferSuccess',
  props: {
  amount: { type: String, required: true },
  currency: { type: String, required: true },
  subaccountFrom: { type: String, required: true },
  subaccountTo: { type: String, required: true },
  symbol: { type: String, required: true },
  variant: { type: String as PropType<ModalVariant>, required: true },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_x_button = _resolveComponent("x-button")!
  const _component_x_modal = _resolveComponent("x-modal")!

  return (_openBlock(), _createBlock(_component_x_modal, {
    class: "subaccount-transfer-success",
    type: "info",
    name: "SubaccountTransferSuccess",
    variant: __props.variant,
    title: _ctx.$t(`modules.transactions.subaccountTransfer.success.title`)
  }, {
    content: _withCtx(() => [
      _createElementVNode("p", null, _toDisplayString(_ctx.$t(`modules.transactions.subaccountTransfer.success.text`, { amount: __props.amount, currency: __props.currency, symbol: __props.symbol, subaccountFrom: __props.subaccountFrom, subaccountTo: __props.subaccountTo })), 1)
    ]),
    buttons: _withCtx(({ clear }) => [
      _createVNode(_component_x_button, {
        variant: "primary",
        text: _ctx.$t(`modules.transactions.subaccountTransfer.success.successButton`),
        onClick: clear
      }, null, 8, ["text", "onClick"])
    ]),
    _: 1
  }, 8, ["variant", "title"]))
}
}

})